// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mouse-tooltip[data-v-07718cb2] {\n    position: fixed;\n    top: -10000px;\n    left: -10000px;\n    background: white;\n    padding: 5px 10px;\n    -webkit-box-shadow: rgba(0, 0, 0, 0.5) -4px 9px 25px -6px;\n            box-shadow: rgba(0, 0, 0, 0.5) -4px 9px 25px -6px;\n    z-index: 5000;\n    opacity: 0;\n}\n.mouse-tooltip.show[data-v-07718cb2] {\n    opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
